import { useGetLoginQuery, useLoginEmailMutation, useLoginEmailVerifyMutation } from "../../redux/loginApi";
import DynamicEditForm from "../DynamicEditForm";
import ModalLoading from "../Modal/ModalLoading";
import useQueryEffect from "/src/hooks/useQueryEffect";
import { useState } from "react";
import ModalError from '../Modal/ModalError';
import { useEffect } from "react";
import useURLSearchParams from "/src/hooks/useURLSearchParams";
import useParseEmailVerify from "/src/hooks/useParseEmailVerify";

const formConfig_email = {
    autoFocus: true,
    saveText: 'Send Verification',
    discardText: '⭯',
    hideDiscard: true,
    hideRequiredHint: true,
    fields: [
        {
            key: 'email',
            title: 'Email',
            type: 'email',
            placeholder: 'johndoe@email.com',
            autocomplete: 'email',
            required: true,
        },
    ],
}

export default function EmailLogin(){
    // const { user } = useAuth();
    const { data: user, error: userError, isLoading: userIsLoading } = useGetLoginQuery(); 
    const [sendEmail, { error: sendError, isLoading: isSending, isSuccess: isSendSuccess }] = useLoginEmailMutation();
    const [verifyEmailToken, { error: verifyError, isLoading: isVerifying, isSuccess: isVerifySuccess }] = useParseEmailVerify();
    const [emailFormInput, setEmailFormInput] = useState({});
    const [sent, setSent] = useState(false);
    const [error, setError] = useState(null);

    // handle email verify link result
    useEffect(()=>{
        if(verifyError){
            setError(verifyError.data);
        }else if(isVerifySuccess){
            // at this point server should have saved user to cookies.
        }
    }, [isVerifySuccess, verifyError]);
    
    // handle email send result
    useEffect(()=>{
        if(sendError){
            setError(sendError.data);
        }else if(isSendSuccess){
            // at this point we are waiting for user to click link in email.
            // show message telling user what to do:
            setSent(true);
        }
    }, [isSendSuccess, sendError]);
    
    // handle email submit button
    function onEmailSubmit(data){
        sendEmail(data.email);
    }

    // console.debug('user:', user);
    
    return (
        <div className="text-left p-6 bg-white flex items-center justify-center">
            {error && <ModalError message={error.message} callback={()=>setError(null)} />}
            {(isSending || isVerifying) && <ModalLoading title={isSending?'Sending':'Checking'} />}
            {(!sent &&
                <DynamicEditForm formConfig={formConfig_email} selectedAsset={emailFormInput} onSave={onEmailSubmit} />
            ) || (
                <div>
                    <h3 className="text-2xl font-light">Verification Sent!</h3>
                    <p className="m-4 max-w-lg">Check your inbox, you should have received an email with a verification link, if not, check your spam folder.</p>
                    <button onClick={()=>setSent(false)} className="btn-invert w-full py-2 mt-2">Back</button>
                </div>
            )}
        </div>
    );
}